module.exports = __webpack_public_path__ + "img/360.d2125915.svg";